
import progreso from './progreso.png';
import logo from './logo_marca.png';
import pelota from './pelota.png';
import fondo  from './FONDO.jpg'
import edit from './edit-solid.svg';


export default {

    "progreso" : progreso,
    'logo' : logo,
    'pelota' : pelota,
    'fondo' : fondo,
    'edit' : edit


}

